import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { initializeLanguage } from './redux/slices/languageSlice';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FloatingContactIcons from './components/FloatingContactIcons/FloatingContactIcons';

function App() {
  const dispatch = useDispatch();
  const { direction } = useSelector((state) => state.language);
  
  // تهيئة اللغة عند تحميل التطبيق
  useEffect(() => {
    dispatch(initializeLanguage());
  }, [dispatch]);
  
  return (
    <div className={`app ${direction === 'rtl' ? 'rtl' : 'ltr'}`}>
      <FloatingContactIcons />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;

// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import HomePage from './pages/HomePage';
// import LoginPage from './pages/LoginPage';
// import DashboardPage from './pages/DashboardPage';
// import ServicesPage from './pages/ServicesPage';
// import AboutPage from './pages/AboutPage';
// import ContactPage from './pages/ContactPage';

// function App() {
//   const { direction } = useSelector((state) => state.language);
  
//   return (
//     <div className={`app ${direction === 'rtl' ? 'rtl' : 'ltr'}`}>
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/dashboard" element={<DashboardPage />} />
//         <Route path="/services" element={<ServicesPage />} />
//         <Route path="/about" element={<AboutPage />} />
//         <Route path="/contact" element={<ContactPage />} />
//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;

// // import React from 'react';
// // import { Routes, Route, Navigate } from 'react-router-dom';
// // import { useSelector } from 'react-redux';
// // import HomePage from './pages/HomePage';
// // import LoginPage from './pages/LoginPage';
// // import DashboardPage from './pages/DashboardPage';
// // import ServicesPage from './pages/ServicesPage'; // أضف هذا الاستيراد
// // import AboutPage from './pages/AboutPage';
// // import ContactPage from './pages/ContactPage';

// // function App() {
// //   const { direction } = useSelector((state) => state.language);
  
// //   return (
// //     <div className={`app ${direction === 'rtl' ? 'rtl' : 'ltr'}`}>
// //       <Routes>
// //         <Route path="/" element={<HomePage />} />
// //         <Route path="/login" element={<LoginPage />} />
// //         <Route path="/dashboard" element={<DashboardPage />} />
// //          <Route path="/services" element={<ServicesPage />} /> {/* أضف هذا المسار */}
// //     <Route path="/about" element={<AboutPage />} />
// //         <Route path="/contact" element={<ContactPage />} />
// //         <Route path="*" element={<Navigate to="/" />} />
// //       </Routes>
// //     </div>
// //   );
// // }

// // export default App;